module.exports = __webpack_public_path__ + "img/frame (181).f9a7f7e9.jpg";